export default "__VITE_ASSET__c810f243__"